<template>
  <v-row id="project-estimate-role-tab">
    <v-col
      class=""
      xl="12"
      lg="12"
    >
      <ProjectEstimatesRoleTable :items="estimationRoles" :allowed="allowed" />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ProjectEstimatesRoleTable from '@/components/projects/PorjectEstimatesRoleTable.vue';

export default {
  components: { ProjectEstimatesRoleTable },
  props: {
    project: {
      type: Object,
      required: true,
    },
    projectId: {
      type: [String, Number],
      required: true,
    },
    allowed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('auth/account', [
      'isUserAdmin',
      'user',
    ]),
    ...mapGetters('projects/main', [
      'projectEstimationRoles',
    ]),
    estimationRoles() {
      return this.projectEstimationRoles;
    },
  },
  created() {
    if (!this.project?.id) return;

    this.loadEstimatesRoles(this.project.id);
  },
  methods: {
    ...mapActions('projects/main', ['getProjectEstimationRoles']),
    async loadEstimatesRoles(projectId) {
      await this.getProjectEstimationRoles({ projectId });
    },
  },
};
</script>
